// src/components/page/home/LoaderWrapper.jsx
import React, { useState, useEffect } from 'react';
import LoadingSpinner from '@/components/home/LoadingSpinner';

const LoaderWrapper = ({ loading, children }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    let timer;
    if (loading) {
      // показуємо оверлей тільки якщо завантаження >300мс
      timer = setTimeout(() => setShowOverlay(true), 300);
    } else {
      setShowOverlay(false);
      clearTimeout(timer);
    }
    return () => clearTimeout(timer);
  }, [loading]);

  return (
    <div className="relative">
      {children}

      {showOverlay && (
        <div className="absolute inset-0 bg-white/70 backdrop-blur-sm flex items-center justify-center z-10">
          <LoadingSpinner />
        </div>
      )}
    </div>
  );
};

export default LoaderWrapper;
